import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'vs-promotout',
  styleUrl: 'vs-promotout.scss',
  shadow: false,
})
export class Promotout {
  @Prop() imageUrl: string = '';
  @Prop() background: 'white' | 'grey' = 'white';
  @Prop() theme: string = '';
  @Prop() imagePosition: 'left' | 'right' = 'right';
  @Prop() mediaType: 'image' | 'video' = 'image';
  @Prop() videoType: 'video-single' | 'video-loop' | 'single' | 'loop' = 'video-single';
  @Prop() autoplay: boolean = true;
  @Prop() muted: boolean = true;
  @Prop() videoAlt: string;
  @Prop() imageAltText: string;
  @Prop() mediaSrc: string = '';
  @Prop() poster: string = '';
  @Prop() titleBlock: string;

  //Change design for Text image comp
  @Prop() variant: string;

  private getVideoType(): 'video-single' | 'video-loop' {
    if (this.videoType === 'single') {
      return 'video-single';
    } else if (this.videoType === 'loop') {
      return 'video-loop';
    }
    return this.videoType;
  }

  private renderMedia() {
    if (this.mediaType === 'video') {
      return (
        <div class="vs-promotout-video-container">
          <vsr-video
            src={this.mediaSrc}
            poster={this.poster}
            video-type={this.getVideoType()}
            autoplay={true}
            muted={true}
            video-alt={this.videoAlt}
          ></vsr-video>
        </div>
      );
    }
    return (
      <div
        class="vs-promotout-image-container"
        style={
          this.mediaSrc && this.mediaSrc ? { '--vsr-image-poster': `url('${this.mediaSrc}')` } : {}
        }
      ></div>
    );
  }

  render() {
    const containerClass = [
      `vs-promotout-container ${this.variant}`,
      `vs-promotout-container-${this.theme}`,
      `${this.background}`,
      `media-${this.imagePosition}`,
    ].join(' ');

    const content = (
      <div class={`vs-promotout-content-wrapper ${this.background}`}>
        <div class="vs-promotout-content-wrapper-title">
          <vsr-title
            title-block={this.titleBlock}
            is-bg-from-parent={true}
            theme={this.theme}
          ></vsr-title>
        </div>
      </div>
    );

    const media = this.renderMedia();

    return (
      <div class={containerClass}>
        {this.imagePosition === 'left' ? media : content}
        {this.imagePosition === 'left' ? content : media}
      </div>
    );
  }
}
